import {useContext} from "react";
import {ModalContext} from "./ModalProvider";
import styles from './DetailModal.module.css';

/**
 * Modal Base Container
 * @param content
 * @param option
 * @returns {JSX.Element}
 * @constructor
 */
function DetailModal({content, option}) {

    const {closeModal} = useContext(ModalContext);

    return (
        <div className={styles.layer__popWrap}>
            <div className={`${styles.layer__popCont} ${styles.user}`}>
                <div className={`${styles.layer__popHeader} ${styles.detail}`}>                 {/* 모달 헤더 */}
                    <span className={styles.layer__popTit}>{option.modalTitle}</span>           {/* 모달 헤더 타이틀 */}
                    <button className={styles.layer__popCloseBtn} onClick={closeModal} />       {/* 모달 헤더 X 버튼 */}
                </div>
                <div className={styles.layer__popDetail}>                                       {/* 모달 Content */}
                    {content}
                </div>

            </div>
        </div>
    )
}

export default DetailModal;